import FormsTextFieldController from "controllers/forms/text_field_controller";
import { ValidationErrors } from "utils/responses";

type FieldToInputMap = Record<string, HTMLElement>;

function displayFormErrors(errors: ValidationErrors, fieldToInputMap: FieldToInputMap, application): void {
  Object.entries(errors).forEach(([field, messages]) => {
    const inputElement = fieldToInputMap[field];
    const inputComponent = inputElement.closest('[data-controller="forms--text-field"]');
    const controller = application.getControllerForElementAndIdentifier(
      inputComponent,
      "forms--text-field",
    ) as FormsTextFieldController;

    controller.showError(messages[0]);
  });
}

export function displayServerErrors(
  error: ValidationErrors | string,
  fallbackTarget: HTMLElement,
  fieldToInputMap: FieldToInputMap,
  application,
) {
  if (typeof error === "string") {
    fallbackTarget.innerText = error;
  } else if (error.base) {
    fallbackTarget.innerText = error.base.join(". ");
  } else {
    displayFormErrors(error, fieldToInputMap, application);
  }
}
